import {
  call, put, select, takeLatest, take, all, cancelled
} from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga'
import { actions, actionCreators } from 'react/api/actions/logoffAlertModal';
import moment from 'moment';

function* clearTime() {
  let [minutes, seconds] = yield call(
    formatTime,
    Monet.Session.User.timeToLogoutAfterOpenModal
  );

  yield put(
    actionCreators.setTimeToCountdown({
      time: Monet.Session.User.timeToLogoutAfterOpenModal,
      actualMinutes: minutes,
      actualSeconds: seconds
    })
  );
  yield call(clearSetIntervalAfterCloseModal, window.greenmileLogoutIntervalId);
}

function clearSetIntervalAfterCloseModal(intervalId) {
  if (intervalId) {
    clearInterval(intervalId);
    window.greenmileLogoutIntervalId = null;
  }
}

function countdown(count) {
  return eventChannel(emitter => {
    const intervalId = setInterval(() => {
      count -= 1000;

      if (count === 3000) {
        const gmStorage = new Greenmile.Storage.StoreMapPosition();
        if (!gmStorage.isUpdate()) {
          const actions = new Greenmile.UserPreferences.Actions();
          actions.saveOrUpdateUserPreferences();
        }
      }

      if (count >= 1000) {
        emitter(count);
      }

      if (count === 0) {
        if (intervalId) {
          clearInterval(intervalId);
          window.greenmileLogoutIntervalId = null;
        }
        emitter(END);
      }

    }, 1000);

    window.greenmileLogoutIntervalId = intervalId;
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        window.greenmileLogoutIntervalId = null;
      }
    }
  })
}

function formatTime(time) {
  const actualTime = moment.duration(time);
  const minutes = actualTime.minutes();
  const seconds = actualTime.seconds();
  return [minutes, seconds];
}

function* setInitalTime() {
  let [minutes, seconds] = yield call(formatTime, Monet.Session.User.timeToLogoutAfterOpenModal);

  yield put(
    actionCreators.setTimeToCountdown({
      time: Monet.Session.User.timeToLogoutAfterOpenModal,
      actualMinutes: minutes,
      actualSeconds: seconds
    })
  );

  const { logoffAlertModal } = yield select();
  const count = logoffAlertModal.getIn(['countdown']);
  const channel = yield call(countdown, count);

  try {
    while (true) {
      let count = yield take(channel);
      let [minutes, seconds] = yield call(formatTime, count);

      yield put(
        actionCreators.setTime({
          time: count - 1000,
          actualMinutes: minutes,
          actualSeconds: seconds
        })
      )
    };
  } finally {
    if (yield cancelled()) {
      channel.close();
    } else {
      Monet.Authentication.logout(true);
      yield put(actionCreators.closeModal());
    }
  }
}

function* watchModalOpening() {
  yield takeLatest(actions.openModal, setInitalTime);
}

function* watchModalClosing() {
  yield takeLatest(actions.closeModal, clearTime);
}

export default function* () {
  yield all([
    watchModalOpening(),
    watchModalClosing()
  ]);
}
